import { render, staticRenderFns } from "./expreimbursfrm.vue?vue&type=template&id=05c152f7"
import script from "./expreimbursfrm.vue?vue&type=script&lang=js"
export * from "./expreimbursfrm.vue?vue&type=script&lang=js"
import style0 from "./expreimbursfrm.vue?vue&type=style&index=0&id=05c152f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports